import { useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const PW_KEY = "sorted_admin_pw";

export default function Admin() {
  const [pw, setPw] = useState(sessionStorage.getItem(PW_KEY) || "");
  const [input, setInput] = useState("");
  const [subs, setSubs] = useState(null);
  const [error, setError] = useState("");

  const load = useCallback(async (password) => {
    try {
      const r = await axios.get(`${API}/admin/submissions`, {
        headers: { "X-Admin-Password": password },
      });
      setSubs(r.data);
      setPw(password);
      sessionStorage.setItem(PW_KEY, password);
      setError("");
    } catch {
      setSubs(null);
      setError("Wrong password.");
      sessionStorage.removeItem(PW_KEY);
    }
  }, []);

  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);

  useEffect(() => {
    if (pw) load(pw);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const downloadCsv = async () => {
    const r = await axios.get(`${API}/admin/submissions.csv`, {
      headers: { "X-Admin-Password": pw },
      responseType: "blob",
    });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = "sorted-submissions.csv";
    a.click();
    URL.revokeObjectURL(url);
  };

  const logout = () => {
    sessionStorage.removeItem(PW_KEY);
    setPw("");
    setSubs(null);
  };

  return (
    <div className="admin-page" data-testid="admin-page">
      <div className="wrap">
        <p className="eyebrow">Sorted · Internal</p>
        <h1 className="admin-title">Founding list submissions</h1>
        {!subs ? (
          <div className="admin-login">
            <p className="admin-sub">Enter the admin password to view registrations.</p>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                load(input);
              }}
            >
              {error && <p className="form-error" data-testid="admin-error">{error}</p>}
              <div className="field">
                <label htmlFor="admin-pw">Admin password</label>
                <input
                  id="admin-pw"
                  type="password"
                  data-testid="admin-password-input"
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="btn-brass" data-testid="admin-login-button">
                View submissions
              </button>
            </form>
          </div>
        ) : (
          <>
            <div className="admin-actions">
              <button className="btn-brass btn-brass--small" onClick={downloadCsv} data-testid="csv-export-button">
                Export CSV
              </button>
              <span className="admin-count" data-testid="admin-count">
                {subs.length} registration{subs.length === 1 ? "" : "s"}
              </span>
              <button className="link-plain" onClick={() => load(pw)} data-testid="admin-refresh">
                Refresh
              </button>
              <button className="link-plain" onClick={logout} data-testid="admin-logout">
                Log out
              </button>
            </div>
            <div className="admin-table-wrap">
              <table className="admin-table" data-testid="admin-table">
                <thead>
                  <tr>
                    <th>Time (UTC)</th>
                    <th>Type</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>WhatsApp</th>
                    <th>Service</th>
                    <th>Area</th>
                  </tr>
                </thead>
                <tbody>
                  {subs.map((s) => (
                    <tr key={s.id} data-testid={`admin-row-${s.id}`}>
                      <td>{new Date(s.created_at).toLocaleString("en-GB")}</td>
                      <td>
                        <span className={s.type === "tasker" ? "admin-badge admin-badge--tasker" : "admin-badge"}>
                          {s.type}
                        </span>
                      </td>
                      <td>{s.name}</td>
                      <td>{s.email}</td>
                      <td>{s.whatsapp || "—"}</td>
                      <td>{s.service || "—"}</td>
                      <td>{s.area}</td>
                    </tr>
                  ))}
                  {subs.length === 0 && (
                    <tr>
                      <td colSpan="7" style={{ color: "var(--muted)" }}>
                        No registrations yet.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
